import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const CloseIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L13 13M13 1L1 13"
      stroke="#92400e"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </svg>
);

function SetupBanner({ app_url }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [setupData, setSetupData] = useState(null);
  const [dismissedSetup, setDismissedSetup] = useState(false);
  const [dismissedTrial, setDismissedTrial] = useState(false);
  const [hoverSetupClose, setHoverSetupClose] = useState(false);
  const [hoverTrialClose, setHoverTrialClose] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchStatus = async () => {
      try {
        const resp = await axios.get(`${app_url}/api/account-setup/status`, { withCredentials: true });
        if (!cancelled && resp.data?.success) {
          setSetupData(resp.data.data);
        }
      } catch (_) {}
    };
    fetchStatus();
    return () => { cancelled = true; };
  }, [app_url]);

  if (location.pathname === '/account-setup') return null;
  if (!setupData) return null;

  const stepsComplete = [setupData.step1_complete, setupData.step2_complete, setupData.step3_complete].filter(Boolean).length;
  const stepsRemaining = 3 - stepsComplete;
  const allComplete = stepsRemaining === 0;

  const trialEndsAt = setupData.trial_ends_at;
  const trialEndsDate = trialEndsAt ? new Date(trialEndsAt) : null;
  const trialEndStr = trialEndsDate
    ? trialEndsDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : null;

  const showSetup = !allComplete && !dismissedSetup;
  const showTrial = !!trialEndStr && !dismissedTrial;

  if (!showSetup && !showTrial) return null;

  const outlinedButtonStyle = {
    border: '1px solid #92400e',
    borderRadius: 6,
    padding: '5px 14px',
    fontSize: 12,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    color: '#92400e',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  };

  const closeButtonStyle = (hovered) => ({
    background: hovered ? '#fef3c7' : 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: '50%',
    padding: 0,
    marginLeft: 4,
    flexShrink: 0,
    transition: 'background 0.15s ease',
  });

  return (
    <div style={{
      position: 'fixed',
      zIndex: 9999,
      bottom: 0,
      left: 280,
      right: 0,
      backgroundColor: '#fffbeb',
      borderTop: '1px solid #fde68a',
      padding: '10px 24px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 8,
    }}>
  {showSetup && (
  <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <span style={{ fontSize: 13, color: '#78350f', fontWeight: 500 }}>
        Your set up is not complete ({stepsRemaining}/{3} steps remaining)
      </span>
      <button onClick={() => navigate('/account-setup')} style={outlinedButtonStyle}>
        Complete Set up
      </button>
    </div>
    <button
      onClick={() => setDismissedSetup(true)}
      onMouseEnter={() => setHoverSetupClose(true)}
      onMouseLeave={() => setHoverSetupClose(false)}
      style={{ ...closeButtonStyle(hoverSetupClose), position: 'absolute', right: 0 }}
      title="Dismiss"
    >
      <CloseIcon />
    </button>
  </div>
)}

{showSetup && showTrial && (
  <div style={{ width: '100%', height: '1px', backgroundColor: '#fde68a' }} />
)}

{showTrial && (
  <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <span style={{ fontSize: 13, color: '#78350f' }}>
        Your free trial ends on {trialEndStr}. Not ready to go?
      </span>
      <button onClick={() => navigate('/pricing')} style={outlinedButtonStyle}>
        See plans
      </button>
    </div>
    <button
      onClick={() => setDismissedTrial(true)}
      onMouseEnter={() => setHoverTrialClose(true)}
      onMouseLeave={() => setHoverTrialClose(false)}
      style={{ ...closeButtonStyle(hoverTrialClose), position: 'absolute', right: 0 }}
      title="Dismiss"
    >
      <CloseIcon />
    </button>
  </div>
)}
    </div>
  );
}

export default SetupBanner;